import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Notification } from '../../../common/notification'
import { COMPONENTS } from '../../../routers/constants'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { LinkComponent } from '../../common/html/LinkComponent'
import { TitleComponent } from '../../common/html/TitleComponent'
import { PopupDetailSuggest } from './components/PopupDetailSuggest'
import { TableInterested } from './components/Table'
import { NUMBER_ITEM_TABLE } from './constant'
import {
  changeIdActive,
  clearCheckbox,
  getLoadingInterested,
  selectIdActive,
  selectIdsTable,
} from './store/slice'
import { getSuggestionCompany } from './store/thunk'

export const Interested = () => {
  const dispatch = useDispatch()

  const loading = useSelector(getLoadingInterested('suggestionCompany'))
  const id = useSelector(selectIdActive)
  const listIdTable = useSelector(selectIdsTable)
  const locale = useSelector((state) => state.i18n.locale)

  const totalPage = useMemo(
    () => Math.ceil(listIdTable.length / NUMBER_ITEM_TABLE),
    [listIdTable.length],
  )

  const [navigate, setNavigate] = useState(1)

  //Actions
  const handleNavigateRight = () => {
    setNavigate((prev) => prev + 1)
  }
  const handleNavigateLeft = () => {
    setNavigate((prev) => prev - 1)
  }
  const onClosePopup = () => {
    dispatch(clearCheckbox())
    dispatch(changeIdActive(undefined))
  }

  const customContentNoData = () => {
    return (
      <>
        <Element
          style={{
            color: '#9C9C9C',
            fontSize: 12,
          }}
          className="w100 textCenter fstItalic"
        >
          <Translate value="dashboard.interested.textNoData" />
          &nbsp;
          <LinkComponent
            href={
              COMPONENTS.userManagement.components.settingsPreferences.route
            }
            style={{
              color: '#2C73E8',
            }}
          >
            <Translate value="dashboard.interested.linkSetting" />
          </LinkComponent>
        </Element>
      </>
    )
  }

  useEffect(() => {
    dispatch(getSuggestionCompany())
  }, [locale])

  return (
    <>
      <LayoutPanel loading={loading} style={{ height: '100%' }}>
        <div className="flexColumn h100">
          <div style={{ paddingBottom: 4 }}>
            <TitleComponent title="dashboard.interested.title" />
          </div>
          <div className="flex1">
            {!listIdTable.length ? (
              <>
                <div className="h100">
                  <Notification customContent={customContentNoData} />
                </div>
              </>
            ) : (
              <>
                {navigate > 1 && (
                  <div
                    className="positionAbsolute"
                    style={{
                      top: '50%',
                      left: 8,
                      transform: 'translateY(-50%)',
                    }}
                  >
                    <Element onClick={handleNavigateLeft}>
                      <Icon
                        className="icon-arrow-circle-left"
                        style={{
                          color: '#2C73E8',
                          fontSize: 15,
                        }}
                      />
                    </Element>
                  </div>
                )}
                <div
                  className="h100"
                  style={{
                    paddingLeft: navigate > 1 ? 24 : 0,
                    paddingRight: navigate < totalPage ? 24 : 0,
                  }}
                >
                  <TableInterested page={navigate} />
                </div>
                {navigate < totalPage && (
                  <div
                    className="positionAbsolute"
                    style={{
                      top: '50%',
                      right: 8,
                      transform: 'translateY(-50%)',
                    }}
                  >
                    <Element onClick={handleNavigateRight}>
                      <Icon
                        className="icon-arrow-circle-right"
                        style={{
                          color: '#2C73E8',
                          fontSize: 15,
                        }}
                      />
                    </Element>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </LayoutPanel>
      {!!id && <PopupDetailSuggest id={id} onClose={onClosePopup} />}
    </>
  )
}
